// TODO: remove this file. Keep it for now because ExpertiseUpdatePage uses it.
import { createContext } from 'react'

type ExpertiseValidationStepperValues = {
  medecin?: string
  network?: string
}

type ExpertiseValidationStepperContextType = {
  activeStep: number
  handleBack: () => void
  handleChange: (field: string, value?: string) => void
  handleNext: () => void
  initialValues: ExpertiseValidationStepperValues
  values: ExpertiseValidationStepperValues
}

type Action = { type: 'next' } | { type: 'back' } | { type: 'setValues'; payload: Partial<ExpertiseValidationStepperValues> }

type State = {
  activeStep: number
  initialValues: ExpertiseValidationStepperValues
  values: ExpertiseValidationStepperValues
}

export function reducer(state: State, action: Action) {
  switch (action.type) {
    case 'next':
      return { ...state, activeStep: state.activeStep + 1 }
    case 'back':
      return { ...state, activeStep: state.activeStep - 1 }
    case 'setValues':
      return { ...state, values: { ...state.values, ...action.payload } }
    default:
      return state
  }
}

export const ExpertiseValidationStepperContext = createContext<ExpertiseValidationStepperContextType>({
  activeStep: 0,
  handleBack: () => {},
  handleChange: () => {},
  handleNext: () => {},
  initialValues: {},
  values: {},
})
